import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, withCtx as _withCtx, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/icons/doctorAvatar.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-lg text-left" }, "Adicionar médico", -1)
const _hoisted_2 = { class: "flex flex-col gap-4 p-4" }
const _hoisted_3 = {
  key: 0,
  class: "flex items-center justify-center py-12"
}
const _hoisted_4 = {
  key: 1,
  class: "flex flex-col max-h-[260px] overflow-y-auto"
}
const _hoisted_5 = ["data-testid"]
const _hoisted_6 = ["value"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Avatar do médico",
  class: "w-full h-full rounded-full object-cover"
}, null, -1)
const _hoisted_8 = { class: "text-left min-w-0 flex-1" }
const _hoisted_9 = { class: "flex items-center gap-2" }
const _hoisted_10 = { class: "font-semibold text-sm text-black truncate" }
const _hoisted_11 = { class: "text-xs text-gray-500" }
const _hoisted_12 = { class: "flex items-center justify-between gap-4" }

import { ref, computed, watch } from 'vue'
import { storeToRefs } from 'pinia'

import { useErrorToast } from '@/composables/useErrorToast'
import { useQualificationDocumentalPolicyStore } from '@/pinia-store/useQualificationDocumentalPolicyStore'
import type { AvailableDoctorResponse } from '@/Network/Types/Responses/QualificationTransferResponses'
import { resolveAvatarSrc } from '@/utils/avatar'
import { formatDoctorName } from '@/utils/string'
import ModalVue from '@/components/designSystem/modals/Modal.vue'
import SearchInput from '@/components/designSystem/Inputs/SearchInput.vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import EmptyList from '@/components/EmptyList.vue'
import ProtectedAvatar from '@/components/designSystem/AvatarUser/ProtectedAvatar.vue'
import LabelBadge from '@/components/designSystem/Badges/LabelBadge.vue'

interface DoctorOption {
  id: number
  name: string
  crm: string
  crmUf: string
  avatarUrl: string | null
  isOutOfScale: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AddDoctorModal',
  props: {
    modalActive: { type: Boolean },
    policyId: {}
  },
  emits: ["close", "add"],
  setup(__props: any, { emit }) {

const props = __props;





const { notifyError } = useErrorToast()
const store = useQualificationDocumentalPolicyStore()
const { availableDoctors: storeAvailableDoctors, isAvailableDoctorsLoading } = storeToRefs(store)

const searchText = ref('')
const selectedDoctorIds = ref<number[]>([])
const isAdding = ref(false)

const allDoctors = computed(() => mapDoctorsResponse(storeAvailableDoctors.value))

const availableDoctors = computed(() => {
  if (!searchText.value) return allDoctors.value
  const query = searchText.value.toLowerCase()
  return allDoctors.value.filter(
    (d) => d.name.toLowerCase().includes(query) || d.crm.toLowerCase().includes(query)
  )
})

const addButtonLabel = computed(() => {
  if (selectedDoctorIds.value.length === 0) return 'Adicionar'
  return `Adicionar (${selectedDoctorIds.value.length})`
})

function mapDoctorsResponse(data: AvailableDoctorResponse[]): DoctorOption[] {
  return data.map((item) => ({
    id: item.id,
    name: item.doctorName,
    crm: item.crm,
    crmUf: item.crmUf,
    avatarUrl: item.avatarUrl,
    isOutOfScale: item.isOutOfScale ?? false
  }))
}

async function loadAvailableDoctors() {
  try {
    await store.fetchAvailableDoctors(props.policyId, { limit: 500 })
  } catch (e) {
    notifyError(e, 'Erro ao carregar médicos disponíveis.')
  }
}

watch(
  () => props.modalActive,
  (active) => {
    if (active) {
      searchText.value = ''
      selectedDoctorIds.value = []
      loadAvailableDoctors()
    }
  }
)

function handleClose() {
  emit('close')
}

async function handleAdd() {
  if (selectedDoctorIds.value.length === 0) return
  isAdding.value = true
  try {
    emit('add', [...selectedDoctorIds.value])
  } finally {
    isAdding.value = false
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_avatar = _resolveComponent("v-avatar")!

  return (_openBlock(), _createBlock(ModalVue, {
    "modal-active": _ctx.modalActive,
    "has-header-border": true,
    "has-footer-border": true,
    "max-width": "max-w-lg",
    "no-body-padding": "",
    onClose: handleClose,
    "data-testid": "add-doctor-modal"
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_12, [
        _createVNode(OutlineButton, {
          text: "Cancelar",
          width: "50%",
          "data-testid": "cancel-add-doctor-button",
          onClick: handleClose
        }),
        _createVNode(FilledButton, {
          text: addButtonLabel.value,
          width: "50%",
          disabled: selectedDoctorIds.value.length === 0 || isAdding.value,
          class: "!bg-primary30",
          "data-testid": "confirm-add-doctor-button",
          onClick: handleAdd
        }, null, 8, ["text", "disabled"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(SearchInput, {
          modelValue: searchText.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchText).value = $event)),
          width: "100%",
          label: "Buscar médico",
          "hide-details": "",
          density: "compact",
          "data-testid": "add-doctor-search-input"
        }, null, 8, ["modelValue"]),
        (_unref(isAvailableDoctorsLoading))
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_v_progress_circular, {
                indeterminate: "",
                color: "primary"
              })
            ]))
          : (availableDoctors.value.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableDoctors.value, (doctor) => {
                  return (_openBlock(), _createElementBlock("label", {
                    key: doctor.id,
                    class: "flex items-center gap-3 px-3 py-3 rounded-lg cursor-pointer hover:bg-gray-50 transition-colors",
                    "data-testid": `select-doctor-${doctor.id}`
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      value: doctor.id,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedDoctorIds).value = $event)),
                      class: "checkbox shrink-0"
                    }, null, 8, _hoisted_6), [
                      [_vModelCheckbox, selectedDoctorIds.value]
                    ]),
                    _createVNode(_component_v_avatar, {
                      size: "36",
                      color: "primary"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(ProtectedAvatar, {
                          src: _unref(resolveAvatarSrc)(doctor.avatarUrl),
                          size: 36
                        }, {
                          default: _withCtx(() => [
                            _hoisted_7
                          ]),
                          _: 2
                        }, 1032, ["src"])
                      ]),
                      _: 2
                    }, 1024),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(formatDoctorName)(doctor.name)), 1),
                        (doctor.isOutOfScale)
                          ? (_openBlock(), _createBlock(LabelBadge, {
                              key: 0,
                              label: "Fora da escala",
                              color: "orange",
                              size: "small",
                              icon: null,
                              class: "shrink-0 whitespace-nowrap",
                              "data-testid": "badge-out-of-scale"
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("p", _hoisted_11, "CRM: " + _toDisplayString(doctor.crm) + "-" + _toDisplayString(doctor.crmUf), 1)
                    ])
                  ], 8, _hoisted_5))
                }), 128))
              ]))
            : (_openBlock(), _createBlock(EmptyList, {
                key: 2,
                title: "Nenhum médico encontrado",
                class: "py-12"
              }))
      ])
    ]),
    _: 1
  }, 8, ["modal-active"]))
}
}

})